export default __webpack_public_path__ + "static/media/logo.2d65db79.png";